export const navigatorFields = [
  [{label: '操作系统', value: 'os'}, {label: '浏览器', value: 'browser'}],
  [{label: '用户代理', value: 'ua'}],
  [{label: 'Flash版本', value: 'flash'}, {label: 'Cookie状态', value: 'cookie'}],
  [{label: 'JavaScript状态', value: 'js'}, {label: 'LocalStorage状态', value: 'lstorage'}],
  [{label: '是否联网', value: 'isConnect'}, {label: '网络类型', value: 'conType'}],
  [{label: '有效带宽', value: 'downspeed'}, {label: '有效RTT', value: 'rtt'}]
]

export const checkNavigator = function () {
  let ua = navigator.userAgent
  let np = navigator.platform

  // os
  let os = np
  let win = 'Win32' === np || 'Windows' === np
  let mac = 'Mac68K' === np || 'MacPPC' === np || 'Macintosh' === np || 'MacIntel' === np
  if (ua.match('iPad') || ua.match('iPhone')) os = 'IOS'
  if (mac) os = 'Mac'
  if (np === 'X11' && !win && !mac) os = 'Unix'
  if (String(np).indexOf('Linux') > -1) os = ua.match('Android') ? 'Android' : 'Linux'
  if (ua.match('Windows CE') || ua.match('WinCE') || ua.match('WindowsCE')) os = 'Windows CE'
  if (ua.match('Windows Mobile')) os = 'Windows Mobile'
  if (ua.match('Windows Phone OS')) os = 'Windows Phone'
  if (ua.match('BlackBerry')) os = 'BlackBerry OS'
  if (ua.match('RIM Tablet OS')) os = 'BlackBerry Tablet OS'
  if (ua.match('(?:web|hpw)OS')) os = 'webOS'
  if (ua.match('SymbianOS/9.1') || ua.match('Series[ ]?60') || ua.match('S60')) os = 'Series60'
  if (win) {
    if (ua.indexOf('Windows NT 5.0') > -1 || ua.indexOf('Windows 2000') > -1) os = 'Win2000'
    if (ua.indexOf('Windows NT 5.1') > -1 || ua.indexOf('Windows XP') > -1) os = 'WinXP'
    if (ua.indexOf('Windows NT 5.2') > -1 || ua.indexOf('Windows 2003') > -1) os = 'Win2003'
    if (ua.indexOf('Windows NT 6.0') > -1 || ua.indexOf('Windows Vista') > -1) os = 'WinVista'
    if (ua.indexOf('Windows NT 6.1') > -1 || ua.indexOf('Windows 7') > -1) os = 'Win7'
    if (ua.indexOf('Windows NT 6.2') > -1 || ua.indexOf('Windows NT 6.3') > -1 || ua.indexOf('Windows 8') > -1) os = 'Win8'
    if (ua.indexOf('Windows NT 6.4') > -1 || ua.indexOf('Windows NT 10.0') > -1 || ua.indexOf('Windows 10') > -1) os = 'Win10'
  }

  // browser
  let j = {}, P = navigator.userAgent, S
  if (window.ActiveXObject) {
    j.name = 'ie'
    j.ver = 9 - (-1 === P.indexOf('Trident/5.0')) - !window.XDomainRequest - !window.XMLHttpRequest
  } else if (document.getBoxObjectFor || window.mozInnerScreenX) {
    j.name = 'firefox'
    j.ver = (S = /(?:Firefox|GranParadiso|Iceweasel|Minefield).(\d+\.\d+)/i.exec(P)) ? parseFloat(S[1]) : 3.3
  } else if (navigator.taintEnabled) {
    if (window.opera) {
      j.name = 'opera'
      j.ver = parseFloat(navigator.appVersion)
    } else {
      j.name = 'ie'
      j.ver = 6
    }
  } else {
    S = /AppleWebKit.(\d+\.\d+)/i.exec(P)
    j.name = 'webkit'
    j.ver = S ? parseFloat(S[1]) : (document.evaluate ? document.querySelector ? 525 : 420 : 419)
    if ((S = /Chrome.(\d+\.\d+)/i.exec(P)) || window.chrome) {
      j.name = 'chrome'
      j.ver = S ? parseFloat(S[1]) : 2
    } else if ((S = /Version.(\d+\.\d+)/i.exec(P)) || window.safariHandler) {
      j.name = 'safari'
      j.ver = S ? parseFloat(S[1]) : 3.3
    }
  }
  let browser = j.name + ':' + j.ver

  // flash
  let Flash, FlashVersion = NaN
  if (window.ActiveXObject) { //IE
    Flash = new ActiveXObject('ShockwaveFlash.ShockwaveFlash')
    if (Flash) FlashVersion = Number(Flash.GetVariable('$version').split(' ')[1].replace(/,/g, '.').replace(/^(d+.d+).*$/, '$1'))
  } else if ((navigator.plugins && navigator.plugins.length > 0)) {
    Flash = navigator.plugins['Shockwave Flash']
    if (Flash) {
      // FlashVersion = Flash.description.split(' ').filter(n => !isNaN(n))[0]
      FlashVersion = (function () {
        let arr = Flash.description.split(' ')
        for (let i = 0; i < arr.length; i++) {
          if (!isNaN(arr[i])) return arr[i]
        }
      })()
    }
  }
  let flash = isNaN(FlashVersion) ? '\u672a\u5b89\u88c5' : FlashVersion

  // cookie
  let cookie = '\u5173\u95ed'
  if (navigator.cookieEnabled) {
    let date = new Date()
    date.setTime(date.getTime() + 1e4)
    document.cookie = 'cookie_test=' + escape('1') + ';expires=' + date.toGMTString()
    let cookieTest = document.cookie.match(new RegExp('(^| )cookie_test=([^;]*)(;|$)'))
    let str = cookieTest ? unescape(cookieTest[2]) : ''
    if (str === '1') cookie = '\u5f00\u542f'
  }

  // localStorage
  let lstorage
  try {
    lstorage = 'localStorage' in window && null !== window.localStorage ? '\u5f00\u542f' : '\u5173\u95ed'
  } catch (e) {
    lstorage = '\u5173\u95ed'
  }

  // navigator.connection
  let isConnect = navigator.onLine ? '\u662f' : '\u5426'
  let conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {type: 'unknown'}
  let conType = 'number' == typeof conn.type ? ['unknown', 'ethernet', 'wifi', '2g', '3g', '4g', 'none'][conn.type] : conn.type ? conn.type : 'unknown'
  let downspeed = conn.downlink
  let rtt = browser.match('chrome') ? conn.rtt : 'browser do not support'

  if (!!downspeed && !isNaN(downspeed)) downspeed += ' M/s'
  if (!isNaN(rtt)) rtt += ' ms'

  // downspeed = ''
  // rtt = 'browser do not support'

  return {
    os, browser, ua,
    flash, cookie, js: '\u5f00\u542f', lstorage,
    isConnect, conType, downspeed, rtt
  }
}

